import { themeV2 } from '@features/lci-report/domain/theme-v2';
import { DEFAULT_FONT } from '@features/lci-report/utils/constants-v2';
import type { PositionProps, TextProps } from '@features/powerpoint';
import type { SlideSection } from '../domain/content';

export const columnV2 = (
  section: SlideSection,
  positionProps: PositionProps
): TextProps => {
  const { items } = section;
  if (items.text.length === 0) return { text: [], options: {} };

  const labelText = section.label
    ? [
        {
          text: section.label,
          options: {
            fontSize: themeV2.fontSizes.h2,
            fontFace: DEFAULT_FONT,
            bold: true,
            breakLine: true,
            color: themeV2.colors.metricBlue,
          },
        },
      ]
    : [];

  return {
    text: [
      ...labelText,
      ...(typeof items.text === 'string' ? [{ text: items.text }] : items.text),
    ],
    options: {
      ...items.options,
      color: themeV2.colors.black,
      fontSize: 10,
      fontFace: DEFAULT_FONT,
      valign: 'top',
      ...positionProps,
    },
  };
};
